import { type ClinicClock } from "@/lib/clinic-clock";

import { type WaitlistEntry, WaitlistStatus } from "@/types/waitlist";

import { acceptableProviderIds } from "./waitlist-provider-choices";
import { matchesWaitlistTime } from "./waitlist-time-preference";

/** Waiting entries whose service, provider, location and time preferences fit a slot. */
export function getMatchingWaitlistEntries(
  entries: WaitlistEntry[] | null | undefined,
  date: Date,
  serviceId: string | undefined,
  locationId: string | undefined,
  providerIds: string[] | undefined,
  /** The slot's clock, from `useClinicClock()` / `useLocationClock()`. */
  clock: ClinicClock,
) {
  return entries?.filter(
    (entry) =>
      entry.status === WaitlistStatus.WAITING &&
      (!serviceId ||
        entry.assignments.some(
          (assignment) => assignment.serviceId === serviceId,
        )) &&
      (!providerIds?.length ||
        entry.assignments.some((assignment) => {
          const chosen = acceptableProviderIds(assignment);
          return (
            chosen.length === 0 || chosen.some((id) => providerIds.includes(id))
          );
        })) &&
      (!locationId || !entry.locationId || entry.locationId === locationId) &&
      matchesWaitlistTime(entry.timePreference, date, clock),
  );
}
